export const GOOGLE_FONTS = {
  "Inter": "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  "Roboto": "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap",
  "Poppins": "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
  "Montserrat": "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
  "Open Sans": "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
  "Lato": "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
  "Doto": "https://fonts.googleapis.com/css2?family=Doto:wght@100..900&display=swap",
  "Lora": "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&display=swap",
  "Merriweather": "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300..900;1,300..900&display=swap",
  "Raleway": "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap",
  "Playfair Display": "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap",
  "Plus Jakarta Sans": "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap",
  "Geist": "https://fonts.googleapis.com/css2?family=Geist:ital,wght@0,100..900;1,100..900&display=swap",
  "Ubuntu": "https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap",
  "Oswald": "https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap",
  "Noto Sans": "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap",
} as const

type FontName = keyof typeof GOOGLE_FONTS | string & {}

export function parseFontNameFromUrl(url: string): string | null {
  try {
    const urlObj = new URL(url)
    const familyParam = urlObj.searchParams.get("family")
    if (!familyParam)
      return null

    // Extract the font name before any colon or weight specifications
    const fontName = familyParam.split(":")[0]
    // Replace plus signs with spaces and decode URI components
    return decodeURIComponent(fontName?.replace(/\+/g, " ") || "")
  }
  catch {
    return null
  }
}

export async function loadGoogleFont(fontUrl: string): Promise<void> {
  return new Promise((resolve) => {
    // Remove any existing Google Fonts link with the same font
    const existingLinks = document.querySelectorAll("link[href*=\"fonts.googleapis.com\"]")
    existingLinks.forEach((link) => {
      if (link.getAttribute("href")?.includes(fontUrl)) {
        link.remove()
      }
    })

    // Add new Google Fonts link
    if (fontUrl) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = fontUrl

      // Handle font loading
      link.onload = async () => {
        // Use Font Loading API to ensure font is actually loaded
        await document.fonts.ready.then(() => {
          resolve()
        })
      }
      link.onerror = (e) => {
        console.error(`Failed to load font: ${fontUrl}`, e)
        resolve() // Resolve anyway to prevent hanging
      }

      document.head.appendChild(link)
    }
    else {
      resolve()
    }
  })
}

export async function setFont(fontUrl: FontName) {
  // Apply font to document root immediately
  const fontName = parseFontNameFromUrl(fontUrl)
  if (fontName) {
    document.documentElement.style.setProperty("--font-family", `'${fontName}', system-ui, sans-serif`)
  }
  // if fontUrl is a valid font name, use it
  else if (fontUrl in GOOGLE_FONTS) {
    document.documentElement.style.setProperty("--font-family", `'${fontUrl}', system-ui, sans-serif`)
  }

  try {
    console.log("Loading font:", fontUrl)
    // Load Google Font if available and wait for it to load
    if (fontUrl in GOOGLE_FONTS) {
      await loadGoogleFont(GOOGLE_FONTS[fontUrl as keyof typeof GOOGLE_FONTS])
    }
    else {
      await loadGoogleFont(fontUrl)
    }

    // Force a re-render after font is loaded
    document.body.style.opacity = "0.99"
    document.body.style.opacity = "1"
  }
  catch (error) {
    console.error("Error loading font:", error)
  }
}
